import {NgModule} from '@angular/core'
import {DetailProgramDescTablaComponent} from './detail-program-desc-tabla/detail-program-desc-tabla.component'
import {ModalProgramDescTablaComponent} from './modal-program-desc-tabla/modal-program-desc-tabla.component'
import {SearchProgramsDescTablaComponent} from './search-programs-desc-tabla/search-programs-desc-tabla.component'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {BrowserModule} from '@angular/platform-browser'
import {CommonModule} from '@angular/common'
import {IconsTextModule} from '../icons-text/icons-text.module'
import {DescriptionModule} from '../../description/description.module'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
import {PipesModule} from '../../../pipes/pipes.module'
import {FormsModule} from '@angular/forms'
import {InfiniteScrollModule} from 'ngx-infinite-scroll'
import {SharedModule} from '../../shared/shared.module'
@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    IconsTextModule,
    DescriptionModule,
    NgbNavModule,
    PipesModule,
    FormsModule,
    InfiniteScrollModule,
    SharedModule
  ],
  declarations: [
    DetailProgramDescTablaComponent,
    ModalProgramDescTablaComponent,
    SearchProgramsDescTablaComponent
  ],
  exports: [
    DetailProgramDescTablaComponent,
    ModalProgramDescTablaComponent,
    SearchProgramsDescTablaComponent
  ],
  providers: []
})
export class ProgramDescTablaModule {
}
